module.exports = "https://redage.akamaized.net/src/views/player/hudevo/phonenew/components/map/map.jpg";